import NotFound from './NotFound';
import SignOut from './SignOut';
import CatchRedirection from './CatchRedirection';

const pages = {
    NotFound,
    SignOut,
    CatchRedirection,
};

export default pages;
